/* eslint import/no-unresolved: off */
/* eslint import/no-webpack-loader-syntax: off */
import normalizeCss from "!raw!normalize.css/normalize.css";
import fonts from "!raw!./cooper-hewitt/stylesheet.css";
import typography from "!raw!../css/typography.css";
import resetCss from "!raw!./reset.css";

// auto-generated at colors/colors.js
const colors = {
  yellow: {
    hex: "#ebe535",
    rgb: [235, 229, 53]
  },
  blue: {
    hex: "#6ea4d5",
    rgb: [110, 164, 213]
  },
  green: {
    hex: "#a4cfab",
    rgb: [164, 207, 171]
  },
  offwhite: {
    hex: "#e6e1d3",
    rgb: [230, 225, 211]
  }
};

export const globalStyles = `
${normalizeCss}
${resetCss}
${fonts}
${typography}
*{
   box-sizing: border-box;
   font-family: Cooper Hewitt;
}
body {
   font-family: "Cooper Hewitt", sans-serif;
   line-height: 1.2;
}
a {
   text-decoration: underline;
   color: black;
   :hover{
       color: ${colors.blue.hex};
   }
}
`;

function generateSizes(accum, count, step) {
  if (accum.length < count) {
    const prev = accum[accum.length - 1];
    return generateSizes(accum.concat(prev * step), count, step);
  }
  return accum.map(n => +n.toFixed(2));
}

const fontSizes = generateSizes([0.2], 25, 1.3).map(f => `${f}vw`);
export const theme = {
  fontSizes,
  space: fontSizes,
  colors
};



// WEBPACK FOOTER //
// ./src/layouts/global-styles.js